var map = {
	"./assets/feature": [
		85284,
		5284
	],
	"./batching/feature": [
		70832,
		9423,
		1699,
		691,
		5365,
		5354,
		1362,
		1658,
		6609,
		8596,
		477,
		3961,
		656,
		8920,
		3397
	],
	"./counterfactual/feature": [
		46528,
		1699,
		9423,
		5354,
		1362,
		8174,
		5950,
		477,
		3961,
		1810,
		8321,
		7354,
		6331,
		8201,
		5705,
		7638
	],
	"./gtf/feature": [
		30582,
		3230,
		582
	],
	"./hypernative/feature": [
		59275,
		9596,
		8321,
		8477
	],
	"./ledger/feature": [
		61681,
		1699,
		1681
	],
	"./myAccounts/feature": [
		998,
		1362,
		8516,
		5354,
		5702,
		2690,
		8596,
		7956,
		9407,
		8617
	],
	"./nfts/feature": [
		35369,
		6660,
		1699,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		691,
		1065
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		3837,
		691,
		5365,
		1699,
		9423,
		5354,
		1362,
		1658,
		6609,
		5950,
		7848,
		8596,
		477,
		3961,
		656,
		8920,
		1810,
		2304,
		7858,
		8391,
		3205
	],
	"./spaces/feature": [
		95009,
		1362,
		5354,
		8516,
		1699,
		691,
		5365,
		9423,
		1658,
		6609,
		5420,
		5909,
		3715,
		8596,
		477,
		3961,
		656,
		8920,
		7956,
		3401,
		9998,
		3129
	],
	"./speedup/feature": [
		77363,
		1699,
		9423,
		477,
		2939
	],
	"./spending-limits/feature": [
		21883,
		1699,
		3483,
		5354,
		1362,
		9423,
		691,
		5365,
		8174,
		1658,
		6609,
		5950,
		7848,
		740,
		5420,
		8596,
		477,
		3961,
		656,
		8920,
		1810,
		8321,
		7354,
		6331,
		2304,
		8201,
		7858,
		8391,
		6163,
		9214,
		1883
	],
	"./stake/feature": [
		77754,
		691,
		5365,
		1699,
		9423,
		5354,
		1362,
		1658,
		6609,
		8596,
		477,
		3961,
		656,
		8920,
		4382
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		21221,
		5365,
		2148,
		1221
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		5365,
		691,
		1699,
		9423,
		5354,
		1362,
		1658,
		6609,
		8596,
		477,
		3961,
		656,
		8920,
		3401,
		7552
	],
	"./tx-notes/feature": [
		73322,
		3322
	],
	"./wallet/feature": [
		71993,
		1993
	],
	"./walletconnect/feature": [
		4390,
		1520,
		691,
		1658,
		6609,
		6847,
		2266,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;